import React, { useState } from "react";
import { Link as RouterLink } from 'react-router-dom';
import _isEmpty from "lodash/isEmpty";
import _get from "lodash/get";
import _map from "lodash/map";
import clsx from "clsx";
import Fade from "react-reveal/Fade";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import toLocale from "../../helpers/toLocale";
import SpaceBox from "../SpaceBox";
import Button from "@material-ui/core/Button";
import Box from "@material-ui/core/Box";
import Slider from "./Slider";
import { SwiperSlide } from 'swiper/react';
import { makeStyles } from "@material-ui/core/styles";
import { PAGES_SLUGS } from "../../constants";
import { Breadcrumb } from "../Breadcrumb";
import HeaderOfferObserver from "../HeaderOfferObserver";
import getSuppotedFileType from "../../helpers/getSuppotedFileType";
import Container from "@material-ui/core/Container";
import ReactHtmlParser from "react-html-parser";
import _size from "lodash/size";
import itemDetailsStyles from "../../theme/itemDetailsStyles";
import { getWishlistData, WL } from "../../helpers/localStorage";
import Icon from "@material-ui/core/Icon";
import CircularProgress from "@material-ui/core/CircularProgress";
import { useDispatch, useSelector } from "react-redux";
import { addCarToWishlist, removeCarFromWishlist } from "../../containers/WishlistPage/actions";
import Snackbar from "@material-ui/core/Snackbar";
import Alert from "@material-ui/lab/Alert";
import { appStyle } from "../../theme/appStyle";
import CountdownBlueWeeks from "../BlueWeeks/Countdown";
import format from "date-fns/format";

const ProductHeroSliderBlueWeeks = (props) => {
    const dispatch = useDispatch();
    const classes = useStyles();
    const { data } = props;
    const [thumbsSwiper, setThumbsSwiper] = useState(null);
    const [open, setOpen] = useState(false);
    const [openRemove, setOpenRemove] = useState(false);
    const updatingWishlist = useSelector(state => state.wishlist.request);

    const archived = _get(data, "archived", false);
    const isUsedCar = _get(data, "car_type", "") === "UsedCar";
    const showEcoBonus = _get(data, "ecobonus", false) && !archived;
    const showElectricEcoBonus = _get(data, "ecobonus_bev", false) && !archived;

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        setOpen(false);
        setOpenRemove(false);
    };

    const addToWishlist = () => {
        setOpenRemove(false);
        dispatch(addCarToWishlist(data.slug));
        setOpen(true);
    }

    const removeFromWishlist = () => {
        setOpen(false);
        dispatch(removeCarFromWishlist(data.slug));
        setOpenRemove(true);
    }

    const renderEcobonus = () => {
        /**
         * ecoBonusData[0] is assigned to hybrid cars
         * ecoBonusData[1] is assigned to electric cars
         */
        const ecoBonusData = _get(props.pageData, "data.ecobonus_section.ecobonus_section", []);

        if (!_isEmpty(ecoBonusData[0]) && showEcoBonus) {
            return ReactHtmlParser(_get(ecoBonusData[0], "attributes.text", ""));
        }

        if (!_isEmpty(ecoBonusData[1]) && showElectricEcoBonus) {
            return ReactHtmlParser(_get(ecoBonusData[1], "attributes.text", ""));
        }

        return null
    }

    const showDiscountPrice = +_get(data,'final_discount_percentage',0) > 0 ;

    return (
        <React.Fragment>
            <Snackbar open={open} onClose={handleClose}
                autoHideDuration={2000}
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                className={classes.customSnackbar}
            >
                <Alert
                    onClose={handleClose}
                    action={''}
                    icon={false}
                    className={`${classes.customAlert} ${classes.alertSuccess}`}
                >
                    ✓ Adăugat cu succes in wish list
                </Alert>
            </Snackbar>
            <Snackbar open={openRemove} onClose={handleClose}
                autoHideDuration={2000}
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                className={classes.customSnackbar}
            >
                <Alert
                    onClose={handleClose}
                    action={''}
                    icon={false}
                    className={`${classes.customAlert} ${classes.alertSuccess}`}
                >
                    <Icon className={clsx("brand-icon-remove")} /> Șters cu succes in wish list
                </Alert>
            </Snackbar>
            <Fade>
                <Grid container className={classes.root}>
                    <Grid item lg={7} xs={12}
                        className={classes.darkGrey}
                    >
                        <Box
                            height={"100%"}
                            display={"flex"}
                            flexDirection={"column"}
                            justifyContent={"space-between"}
                        >
                            <Box display={"block"}>
                                <Slider
                                    effect="fade"
                                    thumbs={{ swiper: thumbsSwiper }}
                                >
                                    {!_isEmpty(_get(data, "photos", [])) && _map(_get(data, "photos", []), (item, index) => {
                                        return <SwiperSlide key={index}>
                                            <div className={clsx(classes.slide)}>
                                                <img
                                                    // Remove lazy load support due to browser POP bug
                                                    src={getSuppotedFileType(_get(item, "big", []))}
                                                    className={clsx(classes.image)} />
                                            </div>
                                        </SwiperSlide>
                                    })}
                                </Slider>
                            </Box>
                            <Box display={"block"} className={classes.thumbRoot}>
                                <Slider
                                    onSwiper={(slider) => {
                                        setThumbsSwiper(slider);
                                    }}
                                    spaceBetween={8}
                                    freeMode={true}
                                    slidesPerView={4}
                                    watchSlidesVisibility={true}
                                    watchSlidesProgress={true}
                                    breakpoints={{
                                        500: {
                                            spaceBetween: 16,
                                            slidesPerView: 5
                                        },
                                    }}
                                >
                                    {!_isEmpty(_get(data, "photos", [])) && _map(_get(data, "photos", []), (item, index) => {
                                        return <SwiperSlide key={index}>
                                            <div className={classes.thumbSlide}>
                                                <img src={getSuppotedFileType(_get(item, "thumb", []))}
                                                    className={clsx(classes.thumbImage)} />
                                            </div>
                                        </SwiperSlide>
                                    })}

                                </Slider>
                            </Box>
                        </Box>
                    </Grid>

                    <Grid item lg={5} xs={12} className={classes.growArea}>
                        <Breadcrumb buttonName={'Modele'} name={_get(data, 'model', '')} />
                        <div className={classes.headerContent}>
                            <Typography
                                variant="h1"
                                component="h1"
                                className={classes.title}
                            >
                                {_get(data, 'name', '')}
                            </Typography>
                            {!isUsedCar && (
                                <Typography
                                    className={classes.sku}
                                    component="p"
                                >
                                    # {_get(data, 'rom_ref', '')}
                                </Typography>
                            )}

                            <div className={`${classes.timerBox}`}>
                                <Box flexGrow={1} bgcolor="primary.dark" pt={3} px={3}>
                                    {archived
                                        ? <Typography
                                            component="div"
                                            className={`${classes.text}`}>
                                            Ne pare rău! Mașină nu mai este disponibilă in oferta Volvo.
                                        </Typography>

                                        : <Box display={"flex"}
                                            alignItems={"center"}
                                            pb={3}
                                        >
                                            <Box>
                                                <span className={`${classes.price} ${classes.whiteText}`}>
                                                    {toLocale(_get(data, "price_data.final_offer_price_with_vat", ""))}€ <span className={classes.tva}>TVA <br />inclus</span>
                                                </span>
                                                {showDiscountPrice &&
                                                    <div className={`${classes.oldPrice} ${classes.colorBlueGrey}`}>
                                                        <span className={`${classes.oldPriceLineThrough}`}>
                                                        {toLocale(_get(data, "price_data.total_price_with_vat", ""))}€
                                                        </span> <span className={classes.tva}>TVA <br />inclus</span>
                                                    </div>}
                                            </Box>

                                            <Box display={"flex"} flexDirection={"column"}>
                                                {_get(data, "final_discount_percentage", false) && <div>
                                                    <div className={`${classes.discountChip}`}>
                                                        -{toLocale(_get(data,'final_discount_percentage'))}%
                                                    </div>
                                                </div>}
                                                <div className={`${classes.blueChip}`}>Blue Weeks</div>
                                            </Box>
                                        </Box>
                                    }

                                    {((showEcoBonus || showElectricEcoBonus) && _size(props.pageData) > 0) && <Typography
                                        component="div"
                                        className={`${classes.text} ${_get(data, "rezervat", true) ? classes.bottomSpacing : ''}`}>
                                        {renderEcobonus()}
                                    </Typography>}

                                    {(_get(data, "rezervat", false) && !archived) && <Typography
                                        component="div"
                                        className={classes.text}>
                                        Această mașină este rezervată.
                                    </Typography>}
                                    <SpaceBox />

                                    <Box className={classes.buttonsContainer}>
                                        {!archived ?
                                            <Button
                                                component={RouterLink}
                                                variant="contained"
                                                classes={{ root: `${classes.button} ${classes.buttonMargin}` }}
                                                to={`/${PAGES_SLUGS.OFFERS}/${_get(data, 'slug', '')}`}
                                            >
                                                Cere ofertă
                                            </Button>
                                            :
                                            <Button
                                                component={RouterLink}
                                                variant="contained"
                                                classes={{ root: `${classes.button} ${classes.buttonMargin}` }}
                                                to={`/${PAGES_SLUGS.PRODUCTS}`}
                                            >
                                                Vezi modele similare
                                            </Button>
                                        }
                                        {!archived &&
                                            <React.Fragment>
                                                {getWishlistData(WL.CAR).includes(_get(data, 'slug', ''))
                                                    ? <Button
                                                        variant="outlined"
                                                        size="large"
                                                        classes={{ root: `${classes.wishlistButton} ${classes.buttonMargin}` }}
                                                        startIcon={<Icon className="brand-icon-heart-fill" />}
                                                        onClick={removeFromWishlist}
                                                        disabled={updatingWishlist}
                                                    >
                                                        Șterge din wish list
                                                        {updatingWishlist &&
                                                            <CircularProgress size={24} className={`${classes.buttonProgress} ${classes.whiteText}`} />}
                                                    </Button>
                                                    : <Button
                                                        variant="outlined"
                                                        size="large"
                                                        classes={{ root: `${classes.wishlistButton} ${classes.buttonMargin}` }}
                                                        startIcon={<Icon className="brand-icon-heart" />}
                                                        onClick={addToWishlist}
                                                        disabled={updatingWishlist}
                                                    >
                                                        Wish list
                                                        {updatingWishlist &&
                                                            <CircularProgress size={24} className={`${classes.buttonProgress} ${classes.whiteText}`} />}
                                                    </Button>
                                                }
                                            </React.Fragment>
                                        }
                                    </Box>

                                    {!archived && isUsedCar && (
                                        <Grid container className={classes.usedCarAttributes}>
                                            <Grid item xs={12}>
                                                <Box display="flex" flexWrap="wrap" className={classes.usedCarAttributesContainer}>
                                                    {isUsedCar && (
                                                        <>
                                                            <Grid item xs={3} container
                                                                direction="column"
                                                                alignItems="center">
                                                                <span className={"brand-icon-medium brand-icon-speed"}> </span>
                                                                <Typography variant={"caption"} align={"center"}>
                                                                    {toLocale(data.km_purchase_date)}km
                                                                </Typography>
                                                            </Grid>
                                                            <Grid item xs={3} container
                                                                direction="column"
                                                                alignItems="center">
                                                                <span className={"brand-icon-medium brand-icon-factory"}></span>
                                                                <Typography variant={"caption"} align={"center"}>
                                                                    {data.manufacturing_year}
                                                                </Typography>
                                                            </Grid>
                                                            <Grid item xs={3} container
                                                                direction="column"
                                                                alignItems="center">
                                                                <svg width="36" height="28" viewBox="0 0 36 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                    <path d="M22.651 14.6854H30.1906V13.1677H22.651V14.6854ZM22.651 9.251H30.1906V7.73329H22.651V9.251ZM5.80938 20.4625H18.7344V20.2177C18.7344 19.1079 18.1632 18.243 17.0208 17.6229C15.9111 17.0027 14.3281 16.6927 12.2719 16.6927C10.2156 16.6927 8.61632 17.0027 7.47396 17.6229C6.36424 18.243 5.80938 19.1079 5.80938 20.2177V20.4625ZM12.2719 13.1187C13.0552 13.1187 13.708 12.8576 14.2302 12.3354C14.7851 11.7805 15.0625 11.1114 15.0625 10.3281C15.0625 9.54475 14.7851 8.89197 14.2302 8.36975C13.708 7.81489 13.0552 7.53746 12.2719 7.53746C11.4885 7.53746 10.8194 7.81489 10.2646 8.36975C9.74236 8.89197 9.48125 9.54475 9.48125 10.3281C9.48125 11.1114 9.74236 11.7805 10.2646 12.3354C10.8194 12.8576 11.4885 13.1187 12.2719 13.1187ZM0.375 27.7083V0.291626H35.625V27.7083H0.375ZM1.89271 26.1906H34.1073V1.80933H1.89271V26.1906Z" fill="black" />
                                                                </svg>
                                                                <Typography variant={"caption"} align={"center"}>
                                                                    {data.first_registration_date}
                                                                </Typography>
                                                            </Grid>
                                                        </>
                                                    )}
                                                </Box>
                                            </Grid>
                                        </Grid>
                                    )}
                                </Box>

                                <Box className={`${classes.countdownContainer}`} bgcolor="primary.dark" p={3}>
                                    <Typography variant={"h1"}
                                        className={`${classes.weight500} ${classes.whiteText}`}>
                                        Grăbește-te să prinzi oferta!
                                    </Typography>
                                    <Box width={"100%"} pt={3}></Box>
                                    <Grid container>
                                        <CountdownBlueWeeks />
                                    </Grid>
                                    <Box width={"100%"} pt={3}></Box>
                                    <Typography variant={"subtitle2"}
                                        className={`${classes.weight300} ${classes.pageSubtitle} ${classes.whiteText}`}>
                                        Livrare imediată <span className={classes.sidePadding}>/</span> 4 ani garanție
                                    </Typography>
                                </Box>
                            </div>
                        </div>
                    </Grid>
                </Grid>
            </Fade>

            <HeaderOfferObserver className={`${classes.offerHeader}`} stickyClass={classes.showHeader}>
                <div className={classes.headerRoot}>
                    <Container>
                        <div className={classes.headerSizing}>
                            <Box
                                display={"flex"}
                                justifyContent={"space-between"}
                                alignItems={"center"}
                                height={"100%"}
                                className={classes.mobileHeaderWrapper}
                            >
                                <Typography
                                    className={`${classes.headerTitle} ${classes.whiteText}`}
                                >
                                    {_get(data, 'name', '')}
                                </Typography>
                                <Box display={"flex"}
                                    alignItems={"center"}
                                    className={classes.mobileTextWrapper}>
                                    {!archived &&
                                        <React.Fragment>
                                            <Box display={"flex"} className={classes.mobilePricesWrapper}>
                                                <span className={`${classes.price} ${classes.whiteText} ${classes.headerPrice}`}>
                                                    {toLocale(_get(data, "price_data.final_offer_price_with_vat", ""))}€ <span className={classes.tva}>TVA <br />inclus</span>
                                                </span>

                                                {showDiscountPrice &&
                                                    <div className={`${classes.oldPrice} ${classes.colorBlueGrey} ${classes.headerOldPrice}`}>
                                                        <span className={classes.oldPriceLineThrough}>
                                                            {toLocale(_get(data, "price_data.total_price_with_vat",  ''))}€
                                                        </span> <span className={classes.tva}>TVA <br />inclus</span>
                                                    </div>
                                                }
                                            </Box>
                                            <Button
                                                component={RouterLink}
                                                variant="contained"
                                                classes={{ root: `${classes.button} ${classes.headerButton}` }}
                                                to={`/${PAGES_SLUGS.OFFERS}/${_get(data, 'slug', '')}`}
                                            >
                                                Cere ofertă
                                            </Button>
                                        </React.Fragment>
                                    }
                                </Box>
                            </Box>
                        </div>
                    </Container>
                </div>

            </HeaderOfferObserver>
        </React.Fragment>
    )
}

const offerHeaderTransition = 0.2;

const useStyles = makeStyles((theme) => ({
    ...appStyle(theme),
    ...itemDetailsStyles(theme),
    root: {
        [theme.breakpoints.up('lg')]: {
            marginBottom: theme.spacing(3),
        },
    },
    darkGrey: {
        background: "#585859",
        overflow: "hidden",
        borderBottomRightRadius: 4,
        borderBottomLeftRadius: 4,
        [theme.breakpoints.up('lg')]: {
            borderBottomLeftRadius: 0,
            borderTopRightRadius: 4,
        }
    },
    slide: {
        position: "relative",
        paddingTop: "56.28%",
        width: "100%",
    },

    image: {
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        width: "100%",
        height: "100%",
    },
    thumbRoot: {
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
        paddingBottom: theme.spacing(2),
        paddingTop: theme.spacing(2),
    },

    thumbSlide: {
        width: "100%",
        paddingTop: "56.17%",
        position: "relative",
        cursor: "pointer",
    },

    thumbImage: {
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        width: "100%",
        height: "100%",
        opacity: 0.4,
        transition: theme.transitions.create(['opacity'], {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen,
        }),
        ".swiper-slide-thumb-active &": {
            opacity: 1,
        },
    },
    header: {
        position: "relative",
    },
    growArea: {
        display: "flex",
        flexDirection: "column",
    },
    timerBox: {
        height: "100%",
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
        borderTopRightRadius: 4,
        borderTopLeftRadius: 4,
        [theme.breakpoints.up('lg')]: {
            borderRadius: 4,
        }
    },
    headerContent: {
        height: "100%",
        display: "flex",
        flexDirection: "column",
        paddingLeft: theme.spacing(1),
        paddingRight: theme.spacing(1),
        [theme.breakpoints.up('lg')]: {
            paddingLeft: theme.spacing(3),
            paddingRight: theme.spacing(3),
        },
    },
    button: {
        backgroundColor: "#fff",
        color: theme.palette.primary.dark,
        marginRight: theme.spacing(3)
    },
    wishlistButton: {
        borderColor: "#fff",
        color: "#fff",
    },
    buttonMargin: {
        marginBottom: theme.spacing(3),
    },
    buttonsContainer: {
        display: "flex",
        [theme.breakpoints.down("sm")]: {
            justifyContent: "center",
        },
    },
    title: {
        letterSpacing: 0,
        fontWeight: theme.typography.fontWeightMedium,
        fontSize: theme.typography.pxToRem(36),
        lineHeight: theme.typography.pxToRem(48),
        paddingBottom: theme.spacing(1),
        [theme.breakpoints.down('sm')]: {
            fontSize: theme.typography.pxToRem(24),
            lineHeight: theme.typography.pxToRem(32),
        },
        [theme.breakpoints.down('md')]: {
            paddingLeft: theme.spacing(3),
            paddingRight: theme.spacing(3),
        },
    },
    sku: {
        color: '#707070',
        fontSize: '14px',
        fontWeight: '300',
        letterSpacing: 0,
        lineHeight: '24px',
        paddingBottom: theme.spacing(2),
        [theme.breakpoints.down('md')]: {
            paddingLeft: theme.spacing(3),
            paddingRight: theme.spacing(3),
        },
    },
    text: {
        color: '#fff',
        letterSpacing: 0,
        fontWeight: theme.typography.fontWeightLight,
        fontSize: theme.typography.pxToRem(18),
        lineHeight: theme.typography.pxToRem(24),
        [theme.breakpoints.down('sm')]: {
            fontSize: theme.typography.pxToRem(16),
        },
        "&$bottomSpacing": {
            marginBottom: theme.spacing(2),
        }
    },
    bottomSpacing: {/*Empty declaration for nested declaration*/ },
    price: {
        fontWeight: theme.typography.fontWeightMedium,
        fontSize: `1.375rem`,
    },
    oldPrice: {
        paddingTop: theme.spacing(1),
        fontSize: `1.125rem`,
    },
    oldPriceLineThrough: {
        textDecoration: "line-through",
    },
    blueChip: {
        ...appStyle(theme).chipBase,
        background: `#2F5790`,
    },
    discountChip: {
        ...appStyle(theme).chipBase,
        background: `#9E2B2B`,
        marginBottom: theme.spacing(1),
    },
    countdownContainer: {
        backgroundColor: `#202A44`
    },
    pageSubtitle: {
        ...appStyle(theme).pageSubtitle,
        marginBottom: 0
    },
    headerRoot: {
        background: theme.palette.primary.dark,
    },
    headerSizing: {
        height: 100,
    },
    offerHeader: {
        zIndex: 1101,
        top: 0,
        opacity: 0,
        visibility: `hidden`,
        width: `100%`,
        position: `fixed`,
        transition: `opacity ${offerHeaderTransition}s 0s, visibility 0s ${offerHeaderTransition}s`
    },
    showHeader: {
        opacity: 1,
        visibility: `visible`,
        transition: `opacity ${offerHeaderTransition}s, visibility ${offerHeaderTransition}s 0s`
    },
    headerTitle: {
        fontSize: `1.125rem`,
        fontWeight: 500,
        lineHeight: `1.5rem`,
        overflow: `hidden`,
        textOverflow: `ellipsis`,
        display: `-webkit-box`,
        lineClamp: 3,
        boxOrient: `vertical`,
        [theme.breakpoints.down('sm')]: {
            fontSize: theme.typography.pxToRem(14),
            lineHeight: theme.typography.pxToRem(20),
        },
    },
    headerPrice: {
        textAlign: `center`,
        marginRight: theme.spacing(2),
        [theme.breakpoints.down('sm')]: {
            textAlign: "left",
            marginRight: theme.spacing(0),
            fontSize: theme.typography.pxToRem(18),
            lineHeight: theme.typography.pxToRem(24),

        },
    },
    headerOldPrice: {
        marginRight: theme.spacing(5),
        padding: 0,
        [theme.breakpoints.down('sm')]: {
            marginRight: theme.spacing(2),
            fontSize: theme.typography.pxToRem(14),
            lineHeight: theme.typography.pxToRem(24),
        },
    },
    headerButtonText: {},
    headerButton: {
        textAlign: `center`,
        fontSize: theme.typography.pxToRem(14),
        [theme.breakpoints.down('sm')]: {
            fontSize: theme.typography.pxToRem(12),
            lineHeight: theme.typography.pxToRem(20),
            padding: theme.spacing(1)
        },
    },

    mobileHeaderWrapper: {
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
        [theme.breakpoints.down('sm')]: {
            flexDirection: `column`,
            justifyContent: `space-evenly`,
            alignItems: `flex-start`,
            paddingLeft: theme.spacing(0),
            paddingRight: theme.spacing(0),
        }
    },
    mobileTextWrapper: {
        [theme.breakpoints.down('sm')]: {
            alignItems: `center`,
            alignSelf: `stretch`,
            justifyContent: `space-between`,
        }
    },
    mobilePricesWrapper: {
        [theme.breakpoints.down('sm')]: {
            flexDirection: `column`
        },
        [theme.breakpoints.up('md')]: {
            alignItems: `center`
        }
    },
    usedCarAttributes: {
        marginTop: theme.spacing(2),
    },
    usedCarAttributesContainer: {
        display: "flex",
        flexWrap: "wrap",
        gap: theme.spacing(4),
        [theme.breakpoints.down("sm")]: {
            gap: theme.spacing(2),
        },
    },
    usedCarAttribute: {
        flex: "1 0 30%",
        minWidth: "150px",
        [theme.breakpoints.down("sm")]: {
            flex: "1 0 100%",
        },
    },
    usedCarAttributeLabel: {
        fontSize: theme.typography.pxToRem(14),
        fontWeight: "300",
    },
    usedCarAttributeValue: {
        fontSize: theme.typography.pxToRem(16),
        fontWeight: theme.typography.fontWeightMedium,
    },
}));

export default ProductHeroSliderBlueWeeks
